/**
 * Mark a user-authored project mutation. Generic save completion may clear
 * `isDirty`, but it cannot mint a generated-artifact child receipt, so the
 * lineage divergence remains until authenticated project hydration replaces
 * the project and re-evaluates its durable ledger.
 */
export function markProjectContentDirty(state: {
  isDirty: boolean
  hasUncommittedArtifactLineage: boolean
}): void {
  state.isDirty = true
  state.hasUncommittedArtifactLineage = true
}
